export default "/fonts/vendor/summernote/dist/summernote.eot?bd0d8be1fbad3612dfe1e6baafd42af3";